import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { EventAvailable, EventBusy } from '@material-ui/icons';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      padding: '8px 0 20px 0',
    },
  })
);

interface Props {
  selectedOperation?: 'availability' | 'unavailability';
  onSelectOperation: (operation: 'availability' | 'unavailability') => void;
}

export function OperationSelect({ selectedOperation, onSelectOperation }: Props) {
  const classes = useStyles();
  const { theme } = useCampfireTheme();

  return (
    <Box className={classes.container}>
      <Box
        style={{
          background: theme.color.white.neutral50,
          border:
            selectedOperation === 'availability' ? `2px solid ${theme.color.secondary.main900}` : '2px solid #DCDCDC',
          borderRadius: '6px',
          padding: '24px 20px',
          cursor: 'pointer',
        }}
        onClick={() => onSelectOperation('availability')}
      >
        <Box display='flex' alignItems={'center'}>
          <EventAvailable style={{ fontSize: '32px', color: theme.color.grey.neutral500, marginRight: '16px' }} />
          <Box>
            <Typography
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '20px',
                color: theme.color.grey.neutralBrand800,
                marginBottom: '4px',
              }}
            >
              Set Availability
            </Typography>
            <Typography
              style={{
                fontSize: '14px',
                lineHeight: '18px',
                color: theme.color.grey.neutral200,
              }}
            >
              Mark specific dates and sessions when you&rsquo;re available
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        style={{
          background: theme.color.white.neutral50,
          border:
            selectedOperation === 'unavailability' ? `2px solid ${theme.color.secondary.main900}` : '2px solid #DCDCDC',
          borderRadius: '6px',
          padding: '24px 20px',
          cursor: 'pointer',
        }}
        onClick={() => onSelectOperation('unavailability')}
      >
        <Box display='flex' alignItems={'center'}>
          <EventBusy style={{ fontSize: '32px', color: theme.color.grey.neutral500, marginRight: '16px' }} />
          <Box>
            <Typography
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '20px',
                color: theme.color.grey.neutralBrand800,
                marginBottom: '4px',
              }}
            >
              Unavailability & Leave
            </Typography>
            <Typography
              style={{
                fontSize: '14px',
                lineHeight: '18px',
                color: theme.color.grey.neutral200,
              }}
            >
              Block out date ranges when you&rsquo;re unavailable
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
